/**
 * Propertyスキーマに関するEnum getter関数
 */
import { PropertyType, Property, PropertyManagementTypeEnum } from "../generated/api";

import { KeyValueObject } from "./keyValueObject";

export const PROPERTY_TYPE_VALUES = {
  owned: PropertyType.NUMBER_0,
  consideration: PropertyType.NUMBER_1,
  proposal: PropertyType.NUMBER_2,
  owned_sample: PropertyType.NUMBER_3,
};

export const isOwnedProperty = (property: Property): boolean => {
  return property.property_type === PROPERTY_TYPE_VALUES.owned;
};
export const isConsiderationProperty = (property: Property): boolean => {
  return property.property_type === PROPERTY_TYPE_VALUES.consideration;
};
export const isProposalProperty = (property: Property): boolean => {
  return property.property_type === PROPERTY_TYPE_VALUES.proposal;
};
export const isOwnedSmapleProperty = (property: Property): boolean => {
  return property.property_type === PROPERTY_TYPE_VALUES.owned_sample;
};

// 「未選択」を除いた管理形態のマッピング。NEW_ という接頭辞は当時の renewal_v1 画面向けに追加された名残だが、
// 現在は物件登録・編集系の各画面で標準的に使われている。
export const NEW_MANAGEMENT_TYPE_KEY_VALUES: KeyValueObject[] = [
  { key: PropertyManagementTypeEnum.MoneyCollectionAgency, value: "管理委託" },
  { key: PropertyManagementTypeEnum.SelfManagement, value: "自主管理" },
  { key: PropertyManagementTypeEnum.Subleasing, value: "サブリース" },
];
